/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Component
 * 
 * 2 = Assembly
 * 
 * 3 = Packing
 * 
 * 4 = NCR
 */
export enum InspectionType {
  Component = 1,
  Assembly = 2,
  Packing = 3,
  NCR = 4
}
